import { getWidth, onResize } from '../utils/window';

export default function cOverlay() {
  window.onload = () => {
    const firstLines = document.querySelectorAll(
      '.c-overlay .c-overlay-container .c-overlay-line:nth-child(2)');
    const secLines = document.querySelectorAll(
      '.c-overlay .c-overlay-container .c-overlay-line:nth-child(4)');

    const cards = document.querySelector('.card-grid.grid.\-has-4');

    if (cards) {
      const firstCard = cards.querySelector('.cell:nth-child(2)');
      const lastCard = cards.querySelector('.cell:nth-child(4)');

      if (firstCard && lastCard) {

        const setOverlay = () => {
          let firstCardPos = getCardPos(firstCard);
          let lastCardPos = getCardPos(lastCard);

          setOverlayLine(firstLines, secLines, firstCardPos, lastCardPos);
        };
        // const bodyPositions = document.body.getBoundingClientRect();

        setOverlay();

        onResize((el) => {
          if (getWidth() > 1080) {
            setOverlay();
          } else {
            resetLinePos(firstLines);
            resetLinePos(secLines);
          }
        });
      }
    }
  };
};

function setOverlayLine(firstLines, secLines, firstLinePos, lastLinePos) {
  setLinePos(firstLines, firstLinePos);
  setLinePos(secLines, lastLinePos);
}

function setLinePos(lines, pos) {
  lines.forEach((el) => {
    el.style.left = pos + 'px';
  });
}

function resetLinePos(lines) {
  lines.forEach((el) => {
    el.style.left = '';
  });
}

function getCardPos(card) {
  // const pos = card.getBoundingClientRect();
  // console.log(card.offsetLeft);
  return card.offsetLeft;
}



// WEBPACK FOOTER //
// ./source/scripts/sections/cOverlay.js